import { PDFViewer, pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import ModalBody, { ModalProps } from './ModalBody';

interface PDFModalProps extends ModalProps {
    PDFComponent: React.FC<any>;
    pdfProps?: Record<string, any>;
    fileName?: string;
    viewerHeight?: number | string;
    viewerWidth?: number | string;
}

const PDFModal: React.FC<PDFModalProps> = ({
    handleClose,
    open,
    PDFComponent,
    pdfProps = {},
    fileName = 'document.pdf',
    viewerHeight = 2500,
    viewerWidth = '100%',
}) => {
    const { t } = useTranslation();
    const doc = <PDFComponent {...pdfProps} />;

    const handleDownload = async () => {
        const blob = await pdf(doc).toBlob();
        saveAs(blob, fileName);
        handleClose();
    };

    return (
        <ModalBody
            title={fileName}
            open={open}
            handleClose={handleClose}
            submitText={capitalizeFirstLetter(t('download'))}
            onSubmit={handleDownload}
            width={'100%'}
        >
            <PDFViewer width={viewerWidth} height={viewerHeight}>
                {doc}
            </PDFViewer>
        </ModalBody>
    );
};

export default PDFModal;
